let config = {
    title: `忍道秘傳：羈絆傳承`,
    copyright: '© 2025 Adam Champagne',
    email: 'crystalm.caroline.d77999@gmail.com',
    policy: 'https://nrakatsukirising.com/g/privacy_policy.html',
    term: 'https://nrakatsukirising.com/g/terms.html',
    introduceTitle: [
        `你的冒險將隨著不斷累積經驗來升級和尋找寶貴道具的關鍵任務而展開。每一步都是對你勇氣的考驗，你將面臨嚴酷的生存條件，逐漸登上忍者地位的巔峰。`,
        `在這個忍者村，你需要不斷收集經驗、道具，並制定休息和狩獵的策略計畫。每一步都至關重要，因為在你從原始忍者走向巔峰的旅程中，你必須一步步忍受嚴酷的生存條件。`,
        `除此之外，你還需要和其他忍者成為朋友，組建自己的忍者聯盟，並尋找傳說中的忍者工具。他們將協助您揭開忍者世界歷史的真相。`
    ],
    introduceText: [
        {
            title: '###生存與成長###',
            text: [
                '收集經驗、聚集資源並制定策略性行動，以在殘酷的忍者世界中生存和發展。'
            ]
        },
        {
            title: '###團隊建立###',
            text: [
                `每個忍者都有獨特的技能和能力。建立終極小隊來執行任務，擊敗敵人，並揭開忍者世界的秘密。`
            ]
        },
        {
            title: '###傳奇工具###',
            text: [
                `尋找散佈在世界各地的傳奇忍者工具。這些強大的神器可以增強你的能力並在戰鬥中提供戰略優勢。`
            ]
        },
        {
            title: '###史詩故事情節###',
            text: [
                `沉浸在深入探究忍者世界歷史的史詩故事情節中。`
            ]
        }
    ]
}
export default config;